export class SettingsRegulationDomain {
  id: any;
  name: any;
  createdDate: any;
  lastUpdatedDate: any;
  numberOfCategories: any;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.createdDate = data.createdDate;
      this.lastUpdatedDate = data.lastUpdatedDate;
      this.numberOfCategories = data.numberOfCategories;
    }
  }
}
